import {withFormsy} from 'formsy-react';
import React, {useState} from 'react';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";

const ScoreItem = React.forwardRef(({ value, label, selected, disabled,onClick }, ref) => (
    <DropdownItem
        ref={ref}
        key={'dropdown' + value}
        tag={'span'}
        onClick={onClick}>
        <div className={'experience ' + (selected && 'selected ') + (disabled && ' disabled')}>

            <p>{label}</p>

            <div className="s-divider"/>

            <i className={selected ? 'fa fa-minus' : 'fas fa-chevron-down'}/>

        </div>
    </DropdownItem>
));

const ExperienceDropdown= React.forwardRef(({value, onChange, disabled}, ref) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const [scoringOptions, setScoringOptions] = useState(laravel.talent_scoring_options);

    const toggle = () => setDropdownOpen(!dropdownOpen);

    let selected = TB.isDefined(value);

    return (
        <div ref={ref}>
            <Dropdown direction={'down'} tag={'span'} toggle={() => !selected && toggle()} isOpen={dropdownOpen}>
                <DropdownToggle tag={'span'} onClick={(event) => {
                    if (selected) {
                        event.preventDefault();
                        return;
                    }
                }}>
                    <div  className={'experience ' + ((dropdownOpen || selected) && 'selected ') + (disabled && ' disabled')}>

                        <p onClick={(event) => {
                            if(selected) {
                                return toggle()
                            }
                        }} style={{width: 135}}>Years</p>

                        <div className="s-divider"/>

                        <i onClick={(event) => {
                            if(selected) {
                                return onChange(undefined)
                            }
                        }} className={selected ? 'fa fa-minus' : (dropdownOpen ?'fas fa-chevron-up' : 'fas fa-chevron-down')}/>

                    </div>

                    {selected && !dropdownOpen && (
                        <div onClick={() => {
                            if(selected) {
                                return toggle()
                            }
                        }} className="experience-result experience">
                            <p>{scoringOptions[value]}</p>
                            <i className="fa fa-chevron-down"/>
                        </div>
                    )}
                </DropdownToggle>

                <DropdownMenu tag={'span'}>
                    {Object.keys(scoringOptions).map((score, i) => (
                        <ScoreItem
                            key={`score-item-${i}`}
                            disabled={disabled}
                            onClick={() => {
                                onChange(score);
                                toggle();
                            }}
                            selected={selected && value === score}
                            label={scoringOptions[score]}
                            value={score}/>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </div>
    );
});


const ExperienceInput = (props) => {

    let {
        label,
        value,
        name,
        setValue,
        getValue,
        disabled
    } = props;


    let className = props.showRequired() ? 'required ' : '';

    className += !props.isValid() && props.isFormSubmitted() ? 'text-danger' : '';
    let inputClassName = !props.isValid() && props.isFormSubmitted() ? 'is-invalid' : '';

    if (props.disabled) {
        inputClassName += ' disabled'
    }

    const errorMessage = props.getErrorMessage();

    return (
        <div className={"form-group " + className}>
            <label className="col-form-label" data-required={props.required}>
                {label}
                {props.required && <span className="required-symbol"> *</span>}
            </label>

            <div className="experience-container">
                <ExperienceDropdown
                    disabled={disabled}
                    value={value}
                    onChange={(input) => {
                        setValue(input)
                    }}
                />
            </div>

            {errorMessage && (
                <div className="invalid-feedback">
                    <div>{errorMessage}</div>
                </div>
            )}
        </div>
    )
}

export default withFormsy(ExperienceInput);
